<template>
  <v-app>
    <!-- color="brown lighten-5" -->
    <v-app-bar app clipped-left clipped-right color="#3f51b5" dark>
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
      <!--
      <img src="@/assets/logo_der_m.png"/>
      -->
      <v-toolbar-title style="width: 600px"> Departamento de Estradas de Rodagem do Paraná</v-toolbar-title>
      <v-spacer />
      <v-tooltip bottom v-if="!autenticado">
        <template v-slot:activator="{ on, attrs }">
          <v-btn  
            color="#3f51b5"
            @click="entrar"             
            v-bind="attrs"
            v-on="on">
            <v-icon large>mdi-login-variant</v-icon>
            Acesso Intranet
          </v-btn>
        </template>
        <span>Login</span>
      </v-tooltip>
      <v-tooltip bottom v-if="autenticado">
        <template v-slot:activator="{ on, attrs }">
          <v-btn  
            color="#3f51b5"
            @click="sair"             
            v-bind="attrs"
            v-on="on">
            <v-icon large>mdi-logout</v-icon>
            Encerrar Acesso
          </v-btn>
        </template>
        <span>Logout</span>
      </v-tooltip>
      <img src="@/assets/logo-celepar-m.png"/>
    </v-app-bar>

    <v-navigation-drawer v-model="drawer" app clipped width="395" color="grey lighten-5"><!--  -->
      <v-list dense nav>
        <v-list-item to="/">
          <v-list-item-icon>
            <v-icon>mdi-layers</v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title>Camadas</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>

      <v-divider/>
      <v-list dense>
        <v-list-group
          prepend-icon="mdi-lan-connect"
          multiple
          active-class=""
          color="#244EA2"
          v-if="autenticado"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Intranet</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item
            to="/pesquisa/imagens"
          >
            <v-list-item-action></v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Imagens de Rodovias (2019)</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            to="/pesquisa/imagens2022"
          >
            <v-list-item-action></v-list-item-action>
            <v-list-item-content>
              <v-list-item-title>Imagens de Rodovias (2022)</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <!--CopControleContratos />
          <CremepControleContratos /-->
          <DenominacaoPontes />
          <DenominacaoRodovias />
          <Desapropriacao />
          <CondicaoMalha />
          
           <v-list-item>
             <template v-slot:default="{ active }">
               <v-list-item-action>
                 <v-checkbox @change="addGraficoMalha" :input-value="active" v-model="drawerGrafico"/>
               </v-list-item-action>
               <v-list-item-content>
                 <v-list-item-title>Condição da Malha Gráficos (2022)</v-list-item-title>
               </v-list-item-content>
             </template>
           </v-list-item>

        <!--v-card color="grey lighten-5" variant="text">
        <v-card-subtitle>Programação Semanal de Serviço</v-card-subtitle>
        <v-list>                   
          <v-list-item><ConservacaoPista /></v-list-item>
          <v-list-item><ConservacaoFaixa /></v-list-item>
          <v-list-item><ConservacaoProseg /></v-list-item>
        </v-list>
      </v-card-->


          <ObrasDT />
          <ProjetosDT />
        </v-list-group>


        <v-list-group
          v-model="rodovias"
          prepend-icon="mdi-road-variant"
          multiple
          active-class=""
          color="#244EA2"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Rodovias Estaduais</v-list-item-title>
            </v-list-item-content>
          </template>

          <Rodovias />

          <v-list-item>
            <template v-slot:default="{ active }">
              <v-list-item-action>
                <v-checkbox @change="addPontosInicioFim" :input-value="active" v-model="pontosInicioFim"/>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Pontos de Início e Fim</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list-group>

        <v-list-group
          prepend-icon="mdi-city-variant-outline"
          color="#244EA2"
          multiple
          active-class=""
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Dados Paraná</v-list-item-title>
            </v-list-item-content>
          </template>

          <Cidades />
          <Povoados />

          <v-list-item>
            <template v-slot:default="{ active }">
              <v-list-item-action>
                <v-checkbox @change="addLimitesMunicipais" :input-value="active" />
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Limites Municipais</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list-group>
        <v-list-group
          prepend-icon="mdi-sign-caution"
          color="#244EA2"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Concessão Paraná</v-list-item-title>
            </v-list-item-content>
          </template>

          <v-list-item>
            <template v-slot:default="{ active }">
              <v-list-item-action>
                <v-checkbox @change="addAnelDaIntegracao" :input-value="active"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Anel da Integração</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
          <v-list-item>
            <template v-slot:default="{ active }">
              <v-list-item-action>
                <v-checkbox @change="addPostosDePedagio" :input-value="active"></v-checkbox>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Postos de Pedágio</v-list-item-title>
              </v-list-item-content>
            </template>
          </v-list-item>
        </v-list-group>

        <v-list-group
          prepend-icon="mdi-office-building-marker"
          no-action
          color="#244EA2"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Superintendências e Escritórios Regionais</v-list-item-title>
            </v-list-item-content>
          </template>

          <Superintendencias />
          <EscritoriosRegionais />
        </v-list-group>

        <v-list-group
          prepend-icon="mdi-pen"
          no-action
          color="#244EA2"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Áreas de Gestão</v-list-item-title>
            </v-list-item-content>
          </template>

          <AreasDeGestao />
        </v-list-group>

        <v-list-group
          prepend-icon="mdi-shovel"
          color="#244EA2"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Programas de Conservação de Rodovias</v-list-item-title>
            </v-list-item-content>
          </template>

          <COP />
          <Cremep />
          <NovosProgConservacao />
          <AntigoAnelIntegracao />

          <FaixaDominio />
          <DispensasLicitacao />
        </v-list-group>

        <v-list-group
          prepend-icon="mdi-alert"
          no-action
          color="#244EA2"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Restrição de Tráfego</v-list-item-title>
            </v-list-item-content>
          </template>

          <RestricaoDeTrafego/>
        </v-list-group>

        <v-list-group
          prepend-icon="mdi-bridge"
          no-action
          color="#244EA2"
        >
          <template v-slot:activator>
            <v-list-item-content>
              <v-list-item-title>Pontes</v-list-item-title>
            </v-list-item-content>
          </template>

          <Pontes />
        </v-list-group>
        <v-btn width="100%" 
            color="#FFFFFF"
            @click="reload"             
            >
            <!--v-icon large>mdi-login-variant</v-icon-->
            Limpar Seleção
          </v-btn>
      </v-list>
    </v-navigation-drawer>

    <v-navigation-drawer v-if="drawerGrafico" right v-model="drawerGrafico" app clipped width="750" color="blue lighten-5">
      <CondicaoMalhaMapas />
    </v-navigation-drawer>

    <v-main>
      <keep-alive>
        <router-view></router-view>
      </keep-alive>
    </v-main>
  </v-app>
</template>

<script>
import store from '@/store/store.js'
import apiCentralSeguranca from '@/api/centralseguranca'

//import CopControleContratos from './views/intranet/CopControleContratos'
//import CremepControleContratos from './views/intranet/CremepControleContratos'
import DenominacaoPontes from './views/intranet/DenominacaoPontes'
import DenominacaoRodovias from './views/intranet/DenominacaoRodovias'
import Desapropriacao from './views/intranet/Desapropriacao'
//import ObrasProjetosDT from './views/intranet/ObrasProjetosDT'
import CondicaoMalha from './views/intranet/CondicaoMalha'
import CondicaoMalhaMapas from './views/intranet/CondicaoMalhaMapas'
import ObrasDT from './views/intranet/ObrasDT'
import ProjetosDT from './views/intranet/ProjetosDT'

import Rodovias from './components/Rodovias'
import Cidades from './components/Cidades'
import Povoados from './components/Povoados'
import Superintendencias from './components/Superintendencias'
import EscritoriosRegionais from './components/EscritoriosRegionais'
import COP from './components/COP'
import Cremep from './components/Cremep'
import NovosProgConservacao from './components/NovosProgConservacao'
import AntigoAnelIntegracao from './components/AntigoAnelIntegracao'
import FaixaDominio from './components/FaixaDominio'
import DispensasLicitacao from './components/DispensasLicitacao'
import AreasDeGestao from './components/AreasDeGestao'
import RestricaoDeTrafego from './components/RestricaoDeTrafego'
import Pontes from './components/Pontes'
import { createWmsLayer } from '@/domain/library'

export default {
  name: 'App',
  components: {
    Rodovias, Cidades, Povoados,
    //CopControleContratos, CremepControleContratos,
    DenominacaoPontes, DenominacaoRodovias,
    Desapropriacao, //ObrasProjetosDT,
    CondicaoMalha, CondicaoMalhaMapas, ObrasDT, ProjetosDT,

    Superintendencias, EscritoriosRegionais,
    COP, Cremep, FaixaDominio, DispensasLicitacao, AreasDeGestao,
    RestricaoDeTrafego, Pontes, NovosProgConservacao,
    AntigoAnelIntegracao
  },
  data: () => ({
    rodovias: [],
    drawer: true,
    drawerGrafico: false,
    pontosInicioFim: true
  }),
  computed: {
    loading () {
      return this.$store.getters.loading
    },
    autenticado() {
      return store.getters.isAuthenticated
    }
  },
  methods: {
    reload () {
      location.reload()
    },
    entrar () {
      this.$store.commit("limparJwtTokenState")
      window.location.href = apiCentralSeguranca.authorizeUrl + '&force_login=true'
    },
    sair () {
      this.$store.commit("limparJwtTokenState")
      location.reload()
      //window.location.href = apiCentralSeguranca.authorizeUrl + '&force_login=true'
    },
    addNovosProgramas(selected) {
      if(selected) {
        this.novoProgLayer = createWmsLayer('der:novo_prog_conservacao_lin_p31982', 'Novos Programas de Conservação')
        this.$root.$emit('addWmsLayer', this.novoProgLayer)
      } else {
        this.$root.$emit('removeWmsLayer', this.novoProgLayer)
      }
    },
    addAntigoAnel(selected) {
      if(selected) {
        this.antigoAnelLayer = createWmsLayer('der:cons_antigo_anel_lin_p31982', 'Antigo Anel de Integração')
        this.$root.$emit('addWmsLayer', this.antigoAnelLayer)
      } else {
        this.$root.$emit('removeWmsLayer', this.antigoAnelLayer)
      }
    },
    addLimitesMunicipais(selected) {
      if(selected) {
        this.limitesMunicipaisLayer = createWmsLayer('der:municipios_pol_p31982', 'Municípios')
        this.$root.$emit('addWmsLayer', this.limitesMunicipaisLayer)
        this.limitesMunicipaisLayer.bringToBack()
      } else {
        this.$root.$emit('removeWmsLayer', this.limitesMunicipaisLayer)
      }
    },
    addPontosInicioFim(selected) {
      if(selected) {
        this.inicioFimLayer = createWmsLayer('der:pontos_inicio_fim_pto_p4674_a2019', 'Pontos de Início e Fim')
        this.$root.$emit('addWmsLayer', this.inicioFimLayer)
      } else {
        this.$root.$emit('removeWmsLayer', this.inicioFimLayer)
      }
    },
    addAnelDaIntegracao(selected) {
      if(selected) {
        this.integracaoLayer = createWmsLayer('der:anel_integracao_lin_p31982', 'Anel de Integração')
        this.$root.$emit('addWmsLayer', this.integracaoLayer)
      } else {
        this.$root.$emit('removeWmsLayer', this.integracaoLayer)
      }
    },
    addPostosDePedagio(selected) {
      if(selected) {
        this.pedagioLayer = createWmsLayer('der:pedagio_pto_p31982', 'Pedágios')
        this.$root.$emit('addWmsLayer', this.pedagioLayer)
      } else {
        this.$root.$emit('removeWmsLayer', this.pedagioLayer)
      }
    },
    addGraficoMalha(selected) {
      this.drawerGrafico = (selected) ? true : false
    },
  },
  mounted () {
   this.$root.$on('initialLayer', () => {
      this.addPontosInicioFim(true)
    })
   //this.pontosInicioFim = true
  }
}
</script>

<style>
#mapid {
  height: calc(100vh - 64px);
}
.leaflet-container {
  z-index: 0;
}

/* Custom Info Control */
.leaflet-info {
  padding: 6px 8px;
  font: 14px/16px Arial, Helvetica, sans-serif;
  background: white;
  background: rgba(255,255,255,0.8);
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
  border-radius: 4px;
/*
  box-shadow: 0 0 15px rgba(0,0,0,0.2);
  border-radius: 5px;
*/
}
.leaflet-info h4 {
  margin: 0 0 5px;
  color: #777;
}
/* Custom Legend Control */
.leaflet-legend {
  line-height: 18px;
  color: #555;
}
.leaflet-legend i {
  width: 18px;
  height: 18px;
  float: left;
  margin-right: 8px;
  opacity: 0.7;
}
/* Custom Changes */

.leaflet-bar {
/*  box-shadow: 0 1px 3px rgba(0,0,0,0.65); */
  box-shadow: 0 1px 5px rgba(0,0,0,.4);
}
.leaflet-popup-content {
  font-family: Roboto;
  font-size: .8125rem;
}
.leaflet-popup-content p {
  margin-top: 8px;
  margin-bottom: 8px !important;
}
/*
.leaflet-popup-content-wrapper {
  border-radius: 4px;
}
.leaflet-popup-content-wrapper, .leaflet-popup-tip {
//  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
  box-shadow: 0 3px 1px -2px rgba(0,0,0,.2), 0 2px 2px 0 rgba(0,0,0,.14), 0 1px 5px 0 rgba(0,0,0,.12);
}
*/
.leaflet-bar a, .leaflet-bar a:hover {
  width: 30px;
  height: 30px;
  line-height: 30px;
  color: black !important;
/*
  color: white !important;
  background-color: black !important;
*/
}
.leaflet-touch .leaflet-bar a{
  width: 30px;
  height: 30px;
  line-height: 30px;
}

/* Custom Controls */
.leaflet-control-clearmap-toggle {
  background-image: url('assets/eraser.svg');
}
.leaflet-control-homeextent-toggle {
  background-image: url('assets/homeextent.svg');
}
.leaflet-control-getfeatureinfo-toggle {
  background-image: url('assets/information-variant.svg');
}
a.leaflet-control-active, a.leaflet-control-active:hover {
  background-color: #4CAF50;
}

/* Geocodificação - Tamanho do Botão */
.leaflet-control-geocoder-icon {
  width: 30px !important;
  height: 30px !important;
}
/* Geoman */
.leaflet-pm-toolbar .leaflet-buttons-control-button {
  padding: 6px;
}

/* Browser Print */
ul.browser-print-holder {
  padding-left: 0px !important;
}
</style>
